const state = {
    settingscostcodes:[],
};

const getters = {
    getSettingsCostcodes: state => state.settingscostcodes,
};

const actions = {
    setSettingsCostcodes: (store, payload) => store.commit("SETTINGSCOSTCODES_SET",payload),
};

const mutations = {
    SETTINGSCOSTCODES_SET: (state, payload) => state.settingscostcodes = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
